import React, { useState, useEffect } from "react";
import TableAHSF from "../../Components/TableAHSF";
import loadConfig from "../../Services/apiService";
import AddAplicatoionInformation from "../../Services/ApplicationInformation/AddAplicationInformation";
import { useNavigate } from "react-router-dom";
import {
  setrefreshApplicationInformation,
  setRefreshTable,
} from "../../Redux/Reducers/VariousVariables";
import { useDispatch, useSelector } from "react-redux";
import PopupAHSF from "../../Components/PopupAHSF";
import GeneralInstructions from "../GeneralInstructions";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import {
  GetActiveRound,
  GetApplicationInformatio,
} from "../../Redux/Reducers/ApplicationInformation";
import GetAplicantInformation from "../../Services/ApplicantInformationPage/GetApplicantInformationData";
import Swal from "sweetalert2";
import LoaderAHSF from "../../Components/LoaderAHSF";

const MainPage = () => {
  const dispatch = useDispatch();
  const [jsonData, setJsonData] = useState({});
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const navigate = useNavigate();
  const [PopupComponentStatus, SetPopupComponentStatus] = useState(false);
  const [canClick, setCanClick] = useState(true);
  const state = useSelector((state) => {
    return {
      ApplicationInformation: state.ApplicationInformation,
      ActiveRound: state.ApplicationInformation.ActiveRound,
    };
  });

  //console.log(
  //   state.ApplicationInformation.loadingApplicationInformation,
  //   "malekjhos"
  // );
  useEffect(() => {
    dispatch(GetActiveRound());
  }, []);
  const RequestAccessor = [
    {
      KeyName: "applicationNumber",
      ShowStatus: true,
      NmaeColumn: " رقم الطلب",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "statusNameAr",
      ShowStatus: true,
      NmaeColumn: "حالة الطلب",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "roundName_",
      ShowStatus: true,
      NmaeColumn: "سنة التقدم",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];

  const OtherMainBtns = [
    {
      Click: async (e) => {
        localStorage.setItem("aI_ApplicationInformationId", e.target.value);
        // dispatch(setrefreshApplicationInformation())
        // بعد انتهاء التحميل

        const applicantinfo = await GetAplicantInformation(e.target.value);
        console.log(applicantinfo, "applicantinfo");
        //اذا كانت موافق على الشروط ينقله الى الطلب اذا غير موافق يظهر له
        //popup  التعليمات العامة
        if (
          // state.ApplicationInformation.ApplicationInformation &&
          // !state.ApplicationInformation.ApplicationInformation.terms
          applicantinfo &&
          !applicantinfo.terms
        ) {
          SetPopupComponentStatus(true);
        } else {
          SetPopupComponentStatus(false);
          navigate("/grants/ApplicationInformation");
        }
      },
      // content: "عرض الطلب",
      // className: "bi bi-eye-fill",
      // id: "editBtn",
      // title: "عرض الطلب",
      // ShowStatus: true,
      // ForSpecificLineName: "aI_ApplicationInformationId",
    },

    {
      Click: async (e) => {
        // const ActiveRoundYear = await dispatch(GetActiveRound());

        if (state.ActiveRound != 1) {
          SetPopupComponentStatus(true);
        }

        // if (canClick) {
        //   setCanClick(false);
        //   const addapp = await AddAplicatoionInformation();
        //   console.log(addapp, "addapp");
        //   //console.log("statusTerms");

        //   if (addapp.data.success == true) {
        //     setCanClick(true);

        //     if (addapp.data.result?.length == 0) {
        //       Swal.fire({
        //         title: addapp.data.message,
        //         icon: "info",
        //         confirmButtonText: "خروج",
        //         cancelButtonText: "الغاء",
        //         showCancelButton: false,
        //         showCloseButton: true,
        //       }).then((res) => {
        //         if (res.isConfirmed) {
        //           window.location.replace("/grants/mainpage");
        //         }
        //       });
        //     } else {
        //       dispatch(setRefreshTable());
        //       window.location.reload();
        //     }
        //   }
        // }
      },
      content:
        state.ActiveRound != 1 ? " انشاء طلب جديد " : "لا يوجد دورة نشطة",
      className: state.ActiveRound != 1 ? "bi bi-plus-square-fill" : "",
      id: state.ActiveRound != 1 ? "AddAppBtn" : "noActiveRound",
      title: "عرض",
      ShowStatus: canClick,
      ForSpecificLineStatus: true,
      ForSpecificLineId: "00000000-0000-0000-0000-000000000000",
      ForSpecificLineName: "aI_ApplicationInformationId",
    },
  ];

  const RequestsColumns = [];
  // send to read props popup

  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: <div>csalmkmkmkkmcskak</div>,
    maxWidth: "100px",
    maxHeight: "100px",
  };
  //to get json data from main.json
  const getJson = async () => {
    var json = await loadConfig();
    //console.log(json, "jjjjj");
    setJsonData(json);
    return json;
  };
  useEffect(() => {
    getJson();
  }, []);

  const closePopupComponent = () => {
    SetPopupComponentStatus(false);
  };

  return jsonData.domainUrl && state.ActiveRound ? (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"aI_ApplicationInformationId"}
        valueButtonAction={"aI_ApplicationInformationId"}
        URL={`api/ApplicationUserReturn/ReturnApplication`}
        // UrlBody={{
        //   aI_ApplicationInformationId: "string",
        // }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={""}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        hideIconsAction={true}
        checkBoks={false}
        nameColumAction=""
        showIconsApplication={true}
        total={false}
        arrayButton={OtherMainBtns}
        ArrayNameDataColum={RequestsColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        // popUpBody2={[<ShowApplication addFun={true} />]}
        // popUpId2={"ShowApplicationpopUp"}
        // popUpBody2={[
        //   <ShowApplication columnId={columnId} list={list} addFun={false} />,
        // ]}
        // handleCloseModal={handleCloseModal}
        // showModal={showPopUp}
      />
      <PopupAHSF
        title={"التعليمات العامة"}
        componentBody={<GeneralInstructions />}
        maxWidth={"70%"}
        maxHeight={"635px"}
        isPopupOpenStatus={PopupComponentStatus}
        isPopupOpenFunction={closePopupComponent}
      />
      <LoaderAHSF show={!canClick} />
    </>
  ) : (
    ""
  );
};

export default MainPage;
